import { request } from '@services'
import { STATUS_REQUEST } from '@utils/constant'

export const state = {
  loading: false,
  data: null,
  errors: null,
  editLoading: false,
  editStatus: null,
  editErrors: null,
}

export const getters = {
  getDetails(state) {
    return state.data
  },
  getErrors(state) {
    return state.errors
  },
  getEditErrors(state) {
    return state.editErrors
  },
  getEditStatus(state) {
    return state.editStatus
  },
}

export const mutations = {
  // details mutations
  SET_DETAILS_AGENT_REQUESTED(state) {
    state.loading = true
  },
  SET_DETAILS_AGENT_RECEIVED(state, newValue) {
    state.loading = false
    state.data = newValue
    state.errors = null
  },
  SET_DETAILS_AGENT_FAILED(state, errors) {
    state.loading = false
    state.data = null
    state.errors = errors
  },
  RESET_DETAILS_AGENT(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },

  // edit mutations
  SET_EDIT_AGENT_REQUESTED(state) {
    state.editLoading = true
    state.editStatus = null
  },
  SET_EDIT_AGENT_RECEIVED(state) {
    state.editLoading = false
    state.editStatus = STATUS_REQUEST.SUCCESS
    state.errors = null
  },
  SET_EDIT_AGENT_FAILED(state, errors) {
    state.editLoading = false
    state.editErrors = errors
    state.editStatus = STATUS_REQUEST.FAILED
  },
  RESET_EDIT_AGENT_AGENT(state) {
    state.editLoading = false
    state.editErrors = null
    state.editStatus = null
  },
  RESET_ALL(state) {
    state.loading = false
    state.data = null
    state.errors = null
    state.editLoading = false
    state.editErrors = null
    state.editStatus = null
  },
}

export const actions = {
  async getDetailsById({ commit }, params) {
    commit('SET_DETAILS_AGENT_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/agent/get/',
        payload: params,
      })
      commit('SET_DETAILS_AGENT_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_DETAILS_AGENT_FAILED', error)
    }
  },
  resetAgentDetails({ commit }) {
    commit('RESET_DETAILS_AGENT')
  },

  async updateAgent({ commit }, params) {
    commit('SET_EDIT_AGENT_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/agent/edit/',
        payload: params,
      })
      commit('SET_EDIT_AGENT_RECEIVED')
      return response
    } catch (error) {
      commit('SET_EDIT_AGENT_FAILED', error)
    }
  },

  resetEditAgent({ commit }) {
    commit('RESET_EDIT_AGENT_AGENT')
  },

  resetAll({ commit }) {
    commit('RESET_ALL')
  },
}
